// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Layouts
import {Grid, GridRow, GridColumn} from '../layouts/Grid';
// Core
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';

export default class GridSystem extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            fixedWidthGridSystem: {
                marginTop: CoreMetrics.Grid.VerticalGutter,
            },
            row: {
                marginBottom: CoreMetrics.Grid.VerticalGutter,
            },
            placeholder: {
                width: "100%",
                backgroundColor: CoreMetrics.Color.Debug,
                verticalAlign: "middle",
                height: CoreMetrics.ElementHeight.Medium(),
            },
        });

        const {variant} = this.props;
        return (
            <div className={css(styles.fixedWidthGridSystem)}>
                <Grid variant={variant}>
                    <GridRow styles={[styles.row]}>
                        <GridColumn><div className={css(styles.placeholder)}></div></GridColumn>
                    </GridRow>
                    <GridRow styles={[styles.row]}>
                        <GridColumn><div className={css(styles.placeholder)}></div></GridColumn>
                    </GridRow>
                    <GridRow styles={[styles.row]}>
                        <GridColumn><div className={css(styles.placeholder)}></div></GridColumn>
                    </GridRow>
                    <GridRow styles={[styles.row]}>
                        {[...Array(2).keys()].map((item, i) => {
                            return <GridColumn key={i}><div className={css(styles.placeholder)}></div></GridColumn>;
                        })}
                    </GridRow>
                    <GridRow styles={[styles.row]}>
                        {[...Array(3).keys()].map((item, i) => {
                            return <GridColumn key={i}><div className={css(styles.placeholder)}></div></GridColumn>;
                        })}
                    </GridRow>
                    <GridRow styles={[styles.row]}>
                        <GridColumn variant={GridColumn.Variant.OneThird}><div className={css(styles.placeholder)}></div></GridColumn>
                        <GridColumn><div className={css(styles.placeholder)}></div></GridColumn>
                    </GridRow>
                    <GridRow styles={[styles.row]}>
                        {[...Array(4).keys()].map((item, i) => {
                            return <GridColumn key={i}><div className={css(styles.placeholder)}></div></GridColumn>;
                        })}
                    </GridRow>
                    <GridRow styles={[styles.row]}>
                        <GridColumn variant={GridColumn.Variant.OneFourth}><div className={css(styles.placeholder)}></div></GridColumn>
                        <GridColumn><div className={css(styles.placeholder)}></div></GridColumn>
                    </GridRow>
                    <GridRow styles={[styles.row]}>
                        {[...Array(6).keys()].map((item, i) => {
                            return <GridColumn key={i}><div className={css(styles.placeholder)}></div></GridColumn>;
                        })}
                    </GridRow>
                    <GridRow styles={[styles.row]}>
                        {[...Array(12).keys()].map((item, i) => {
                            return <GridColumn key={i}><div className={css(styles.placeholder)}></div></GridColumn>;
                        })}
                    </GridRow>
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/demo/GridSystem.jsx